var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaciousNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.77344,
    y: 2.9043,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.77344,
    y: 10.9746,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.77344,
    y: 19.0469,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.77344,
    y: 27.1172,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 3.44263L1.9858 6.13296H5.09233L3.53906 3.44263ZM3.8081 10.4375L3.8081 5.86393H3.27003L3.27003 10.4375H3.8081Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 31.1531L5.09233 28.4627L1.9858 28.4627L3.53906 31.1531ZM3.27003 24.1582L3.27003 28.7318L3.8081 28.7318L3.8081 24.1582L3.27003 24.1582Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaciousNew);
export default __webpack_public_path__ + "static/media/Spacious_New.f0f654b23a1cbec1a3478d98f1495bcb.svg";
export { ForwardRef as ReactComponent };